import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/maps/close.svg'


const _hoisted_1 = { class: "filter-select-label" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = {
  key: 0,
  class: "filter-select-options"
}
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "refDropdownList",
    class: _normalizeClass({ 'filter-select': true, 'filter-select--open': _ctx.isOpen })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "filter-select-name",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
      }, _toDisplayString(_ctx.currentText), 1),
      _createElementVNode("span", {
        class: "filter-select-close",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: _ctx.$t('components.filterSelect.close_alt')
        }, null, 8, _hoisted_2)
      ])
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              key: option.value,
              class: "components-checkbox components-checkbox--left"
            }, [
              _withDirectives(_createElementVNode("input", {
                id: `${_ctx.prefix}-${option.value}`,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value) = $event)),
                type: "checkbox",
                value: option.value
              }, null, 8, _hoisted_4), [
                [_vModelCheckbox, _ctx.value]
              ]),
              _createElementVNode("label", {
                for: `${_ctx.prefix}-${option.value}`
              }, _toDisplayString(option.text), 9, _hoisted_5)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}